import type {
  GymHealthDeclarationFormState,
  GymHealthDeclarationWirePayload,
} from '../types/gymHealthDeclaration';
import { GYM_HEALTH_DECLARATION_BOOL_KEYS } from '../types/gymHealthDeclaration';

export function gymHealthDeclarationFormIsComplete(form: GymHealthDeclarationFormState): boolean {
  if (!form.gender || !form.birthYear || !form.birthMonth || !form.birthDay) {
    return false;
  }
  for (const key of GYM_HEALTH_DECLARATION_BOOL_KEYS) {
    if (form[key] === null) {
      return false;
    }
  }
  return form.declaration_agreed;
}

export function buildGymHealthDeclarationWirePayload(
  form: GymHealthDeclarationFormState,
): GymHealthDeclarationWirePayload {
  const y = form.birthYear.padStart(4, '0');
  const m = form.birthMonth.padStart(2, '0');
  const d = form.birthDay.padStart(2, '0');
  return {
    gender: form.gender as GymHealthDeclarationWirePayload['gender'],
    birth_date: `${y}-${m}-${d}`,
    answers: {
      heart_disease: form.heart_disease === true,
      chest_pain_at_rest: form.chest_pain_at_rest === true,
      chest_pain_daily_activity: form.chest_pain_daily_activity === true,
      chest_pain_exercise: form.chest_pain_exercise === true,
      dizziness_balance_loss: form.dizziness_balance_loss === true,
      loss_of_consciousness: form.loss_of_consciousness === true,
      asthma_recent_symptoms: form.asthma_recent_symptoms === true,
      family_heart_disease_death: form.family_heart_disease_death === true,
      family_sudden_early_death: form.family_sudden_early_death === true,
      doctor_supervised_activity_only: form.doctor_supervised_activity_only === true,
      other_chronic_limiting_condition: form.other_chronic_limiting_condition === true,
      high_risk_pregnancy: form.high_risk_pregnancy === true,
      smoker: form.smoker === true,
    },
    declaration_agreed: form.declaration_agreed,
  };
}
